import React from "react";

const key = (value) => String(value || "").toLocaleLowerCase("sv-SE").replace(/\s+/g, " ").trim();
const hasScore = (score) => score != null && score !== "" && Number.isInteger(Number(score)) && Number(score) >= 0;

export function projectTable(standings, matches, predictions, rules = {}) {
  const rows = (standings || []).map((row) => ({ ...row, original_position: row.position, simulated: 0 }));
  const byName = new Map(rows.map((row) => [key(row.team), row]));
  const points = { win: 3, draw: 1, loss: 0, otWin: 2, otLoss: 1, disallowDraws: true, ...rules };
  let simulated = 0;
  for (const match of matches) {
    if (match.home_goals != null || match.away_goals != null) continue;
    const tip = predictions[match.id];
    if (!tip || !hasScore(tip.pred_home) || !hasScore(tip.pred_away)) continue;
    const home = byName.get(key(match.home_team));
    const away = byName.get(key(match.away_team));
    if (!home || !away) continue;
    const homeGoals = Number(tip.pred_home);
    const awayGoals = Number(tip.pred_away);
    if (homeGoals === awayGoals && points.disallowDraws) continue;
    home.played += 1;
    away.played += 1;
    home.goal_difference += homeGoals - awayGoals;
    away.goal_difference += awayGoals - homeGoals;
    home.simulated += 1;
    away.simulated += 1;
    simulated += 1;
    if (homeGoals === awayGoals) {
      home.points += points.draw;
      away.points += points.draw;
    } else {
      const winner = homeGoals > awayGoals ? home : away;
      const loser = winner === home ? away : home;
      const extra = tip.pred_result_type === "ef" || tip.pred_result_type === "es";
      winner.points += extra ? points.otWin : points.win;
      loser.points += extra ? points.otLoss : points.loss;
    }
  }
  rows.sort((a, b) => b.points - a.points || b.goal_difference - a.goal_difference || a.original_position - b.original_position);
  return { rows, simulated };
}

export default function SimulationTable({ standings, matches, predictions, rules, currentTeams = [] }) {
  if (!standings?.length) return <p className="tips-empty">Tabellen är inte tillgänglig ännu.</p>;
  const { rows, simulated } = projectTable(standings, matches, predictions, rules);
  const highlighted = new Set(currentTeams);
  return <section className="standings-card tips-projection">
    <header><h2>Simulerad tabell</h2><span>{simulated} {simulated === 1 ? "tippad match" : "tippade matcher"} inräknade</span></header>
    <div className="standings-table" role="table" aria-label="Simulerad tabell">
      <div className="standings-row standings-row--head" role="row"><span>#</span><span>Lag</span><span>M</span><span>+/-</span><span>Poäng</span></div>
      {rows.map((row, index) => <div className={`standings-row${highlighted.has(row.team) ? " standings-row--current" : ""}`} role="row" key={row.team_id || row.team}>
        <strong>{index + 1}</strong><span className="standings-team">{row.logo && <img src={row.logo} alt="" />}<span>{row.team}{row.simulated > 0 && <small className="tips-projection-mark">+{row.simulated}</small>}</span></span><span>{row.played}</span><span>{row.goal_difference > 0 ? "+" : ""}{row.goal_difference}</span><strong>{row.points}</strong>
      </div>)}
    </div>
  </section>;
}
